import styled from "@emotion/styled";
import { AppNavbar } from "@features/Chat/components/AppNavbar";
import { useUIStore } from "@store/ui.store";
import {
  SIDEBAR_WIDTH_COLLAPSED_PX,
  SIDEBAR_WIDTH_EXPANDED_PX,
} from "@shared/layouts/sidebar-dimensions";

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  background-color: ${(p) => p.theme.colors.background};
`;

export const HeaderSlot = styled.header<{ $isSidebarOpenDesktop?: boolean }>`
  flex-shrink: 0;
  background-color: ${(p) => p.theme.colors.background};
  display: flex;
  align-items: stretch;
  min-height: 4rem;

  ${(p) => p.theme.media.mobileDown} {
    min-height: 4.5rem;
  }

  & > * {
    width: 100%;
  }
  transition:
    margin-left 0.3s ease-in-out,
    width 0.3s ease-in-out;
  width: ${(p) =>
    p.$isSidebarOpenDesktop
      ? `calc(100% - ${SIDEBAR_WIDTH_EXPANDED_PX}px)`
      : `calc(100% - ${SIDEBAR_WIDTH_COLLAPSED_PX}px)`};
  margin-left: ${(p) =>
    p.$isSidebarOpenDesktop
      ? `${SIDEBAR_WIDTH_EXPANDED_PX}px`
      : `${SIDEBAR_WIDTH_COLLAPSED_PX}px`};

  ${(p) => p.theme.media.laptopDown} {
    width: 100%;
    margin-left: 0;
  }
`;

export const ContentScroll = styled.div<{ $isSidebarOpenDesktop?: boolean }>`
  flex: 1;
  padding: 2rem 4rem;
  overflow-y: auto;
  transition:
    margin-left 0.3s ease-in-out,
    width 0.3s ease-in-out;
  width: ${(p) =>
    p.$isSidebarOpenDesktop
      ? `calc(100% - ${SIDEBAR_WIDTH_EXPANDED_PX}px)`
      : `calc(100% - ${SIDEBAR_WIDTH_COLLAPSED_PX}px)`};
  margin-left: ${(p) =>
    p.$isSidebarOpenDesktop
      ? `${SIDEBAR_WIDTH_EXPANDED_PX}px`
      : `${SIDEBAR_WIDTH_COLLAPSED_PX}px`};

  ${(p) => p.theme.media.laptopDown} {
    width: 100%;
    margin-left: 0;
    padding: 1rem;
  }
`;

export const ContactsLayout = ({
  children,
  header,
}: {
  children?: React.ReactNode;
  header?: React.ReactNode;
}) => {
  const isSidebarOpenDesktop = useUIStore(
    (state) => state.isSidebarOpenDesktop,
  );

  return (
    <LayoutContainer>
      <HeaderSlot $isSidebarOpenDesktop={isSidebarOpenDesktop}>
        {header ?? <AppNavbar />}
      </HeaderSlot>
      <ContentScroll $isSidebarOpenDesktop={isSidebarOpenDesktop}>
        {children}
      </ContentScroll>
    </LayoutContainer>
  );
};
